function isRatingSurveyResponse(response) {
  return typeof response === "object" && response !== null && "name" in response && typeof response.name === "string" && "rating" in response && typeof response.rating === "number" && response.rating > 0 && response.rating <= 5;
}
function isRatingSurveyResponseList(response) {
  return Array.isArray(response) && response.every(isRatingSurveyResponse);
}
function isSimpleSurveyResponse(response) {
  return typeof response === "object" && response !== null && "value" in response && typeof response.value === "string";
}
function isComplexAnswerResponse(response) {
  if (isRatingSurveyResponseList(response)) {
    return true;
  }
  if (isSimpleSurveyResponse(response)) {
    return true;
  }
  return false;
}
function complexAnswersToPublicAPIFormat(answers, questions) {
  return answers.map((answer) => {
    const question = questions.find((q) => q.id === answer.question_id);
    if (!question) {
      return null;
    }
    const answerPublicApi = {
      question: question.question,
      response: answer.response,
      type: question.type
    };
    return answerPublicApi;
  }).filter((a) => a !== null);
}
export {
  complexAnswersToPublicAPIFormat,
  isComplexAnswerResponse,
  isRatingSurveyResponse,
  isRatingSurveyResponseList,
  isSimpleSurveyResponse
};
//# sourceMappingURL=answer.js.map
